export default function SparkleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="17"
      height="20"
      viewBox="0 0 27 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.33c0-.56 2.2-1.77 6-2.57 2.53-.53 4.57-2.53 4.93-5.07C11.68 3.5 12.9 0 13.53 0c.64.05 1.83 3.52 2.55 8.65.36 2.56 2.4 4.57 4.95 5.13 3.68.81 5.83 2.03 5.83 2.55 0 .52-2.18 1.67-5.89 2.45-2.53.53-4.56 2.54-4.91 5.08-.72 5.18-1.91 8.71-2.63 8.71-.71 0-1.87-3.48-2.56-8.6-.35-2.57-2.41-4.6-4.98-5.13C1.43 18.07 0 16.89 0 16.33Z"
        fill="url(#sparkle_loading)"
      />
      <path
        d="M20.82 2.35c.28-.19 1.31.64 2.52 2.01.4.45 1.07.57 1.6.27 1.56-.88 2.76-1.37 2.96-1.03.2.34-.63 1.26-1.98 2.41-.46.39-.58 1.05-.28 1.57.88 1.52 1.34 2.63 1.01 2.96-.33.33-1.3-.58-2.47-1.94-.39-.46-1.06-.57-1.59-.27-1.56.87-2.74 1.34-2.96 1.03-.22-.31.62-1.25 1.98-2.4.46-.39.58-1.05.28-1.58-.89-1.59-1.33-2.82-1.07-3.03Z"
        fill="url(#sparkle_loading2)"
      />
      <defs>
        <linearGradient
          id="sparkle_loading"
          x1="0"
          y1="0"
          x2="27"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2021C6" />
          <stop offset="0.5" stopColor="#2342FD" />
          <stop offset="1" stopColor="#2021C6" />
        </linearGradient>
        <linearGradient
          id="sparkle_loading2"
          x1="20"
          y1="2"
          x2="27"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2021C6" />
          <stop offset="0.5" stopColor="#2342FD" />
          <stop offset="1" stopColor="#2021C6" />
        </linearGradient>
      </defs>
    </svg>
  );
}
